export default __webpack_public_path__ + "static/media/company.da3937f9.svg";